export default __webpack_public_path__ + "static/media/Website-passcode-Banner-new-340X340.1d25c7fa.jpg";